module.exports = {
  PERIOD_SELECTED: 'PERIOD_SELECTED',
  PERIOD_SELECTED_WEEK: 'PERIOD_SELECTED_WEEK',
  PERIOD_SELECTED_MONTH: 'PERIOD_SELECTED_MONTH',
  PERIOD_SELECTED_DAY: 'PERIOD_SELECTED_DAY',
  DATE_FIELD_SELECTED: 'DATE_FIELD_SELECTED',
  DATE_PICKER_SELECTED: 'DATE_PICKER_SELECTED',
  PERIOD_LAST_SELECTION: 'PERIOD_LAST_SELECTION',
};
